import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { ItemUnavailableMessage } from 'components/item-unavailable-message';
import { MediaQuery, useMediaQuery } from 'hooks/use-media-query';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';
import { useLocationContext } from 'state/location';
import { useMenuContext } from 'state/menu';
import { useProductWizardContext } from 'state/product-wizard';
import { routes } from 'utils/routing';

import { CheckAvailabilityButton, StyledActionButton } from '../styled';
import { useProductAvailability } from '../use-product-availability';

import { ProductCtaWrapper } from './product-cta-wrapper';

export const ProductStaticMenuCta: React.FC<{ showStaticPickers?: boolean }> = ({
  showStaticPickers,
}) => {
  const { location, navigate } = useLocationContext();
  const { setSelectedStaticMenuItem } = useMenuContext();
  const { menuObject } = useProductWizardContext();

  const { formatMessage } = useIntl();
  const { dayParts, isItemAvailableForDaypart, itemDayParts } = useProductAvailability();
  const isDesktop = useMediaQuery(MediaQuery.Desktop);
  const enableCheckAvailabilityToDelivery = useFlag(
    LaunchDarklyFlag.ENABLE_CHECK_AVAILABILITY_TO_DELIVERY
  );

  const handleFindRestaurantClick = useCallback(() => {
    const { _type, _id, name } = menuObject;
    setSelectedStaticMenuItem({
      itemId: `${_type}-${_id}`,
      itemName: name?.locale,
      search: location.search,
    });
    if (enableCheckAvailabilityToDelivery) {
      navigate(routes.address);
    } else {
      navigate(routes.storeLocator);
    }
  }, [
    location.search,
    menuObject,
    navigate,
    setSelectedStaticMenuItem,
    enableCheckAvailabilityToDelivery,
  ]);

  return (
    <ProductCtaWrapper
      hideShadow={isDesktop && !showStaticPickers}
      button={
        !isItemAvailableForDaypart ? (
          <ItemUnavailableMessage
            dayParts={dayParts}
            itemDayParts={itemDayParts}
            marginAndBorders={isDesktop && !showStaticPickers}
          />
        ) : (
          <StyledActionButton onClick={handleFindRestaurantClick} fullWidth={false}>
            <CheckAvailabilityButton data-testid="check-availability-button">
              {formatMessage({ id: 'checkAvailability' })}
            </CheckAvailabilityButton>
          </StyledActionButton>
        )
      }
    />
  );
};
